/**
 * @generated SignedSource<<6bd199e9c4ef61e2ea18b97ab4d503e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchListItem_StoreProductExpireBatch$data = {
  readonly activeAction: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchListItemAction_StoreProductExpireBatchAction">;
  } | null;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchListItemContent_StoreProductExpireBatch">;
  readonly " $fragmentType": "ProductExpireBatchListItem_StoreProductExpireBatch";
};
export type ProductExpireBatchListItem_StoreProductExpireBatch$key = {
  readonly " $data"?: ProductExpireBatchListItem_StoreProductExpireBatch$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchListItem_StoreProductExpireBatch">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductExpireBatchListItem_StoreProductExpireBatch",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProductExpireBatchAction",
      "kind": "LinkedField",
      "name": "activeAction",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductExpireBatchListItemAction_StoreProductExpireBatchAction"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductExpireBatchListItemContent_StoreProductExpireBatch"
    }
  ],
  "type": "StoreProductExpireBatch",
  "abstractKey": null
};
})();

(node as any).hash = "8a485e822cc10c0db063d5adbe73200b";

export default node;
